var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container lnb d_container"},[_c('div',{staticClass:"contents_wrap"},[_c('div',{staticClass:"contents list-container"},[_c('div',{staticClass:"title"},[_vm._v(" 프리미엄 마켓 ")]),_vm._m(0),_c('div',[_c('premium-file-component')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb10"},[_vm._v(" 이미지 W X W 사이즈에 최적화 되어 있습니다."),_c('br'),_vm._v(" 저장버튼을 눌러야 배너가 반영됩니다. "),_c('br')])
}]

export { render, staticRenderFns }